import { render, staticRenderFns } from "./NotificationSettingDisplayArea.vue?vue&type=template&id=0dda0ac8&scoped=true"
import script from "./NotificationSettingDisplayArea.vue.js?vue&type=script&lang=js&external"
export * from "./NotificationSettingDisplayArea.vue.js?vue&type=script&lang=js&external"
import style0 from "./NotificationSettingDisplayArea.vue?vue&type=style&index=0&id=0dda0ac8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dda0ac8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRadio,VRadioGroup,VRow})
